import { render, staticRenderFns } from "./Branch.vue?vue&type=template&id=701deeba&scoped=true"
import script from "./Branch.vue?vue&type=script&lang=js"
export * from "./Branch.vue?vue&type=script&lang=js"
import style0 from "./Branch.vue?vue&type=style&index=0&id=701deeba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701deeba",
  null
  
)

export default component.exports